<template>
  <hgroup>
    <Component :is="isHero ? 'h1' : 'h2'" class="font-semibold">
      {{ heading }}
    </Component>
    <p v-if="subHeading">
      {{ subHeading }}
    </p>
  </hgroup>
</template>

<script setup lang="ts">
defineProps<{
  heading: string
  subHeading?: string
}>()

const isHero = inject<boolean>('isHero', false)
</script>
